module.exports = __webpack_public_path__ + "static/media/5h.c93ca04c.jpg";